exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-cbb976ac],td[data-v-cbb976ac],th[data-v-cbb976ac]{border:1px solid #000;border-collapse:collapse}td[data-v-cbb976ac],th[data-v-cbb976ac]{padding:5px;text-align:center}.modal-container[data-v-cbb976ac]{background-color:#fff;overflow-y:auto!important;height:100%;overflow-x:hidden;padding-bottom:20px}@media (max-width:800px){.modal-container[data-v-cbb976ac]{height:55vh}}.form-content-body[data-v-cbb976ac]{height:100%}.modal-header[data-v-cbb976ac]{height:100%!important}", ""]);

// exports
